module.exports = __webpack_public_path__ + "static/media/APOTHEO_LABO_MARQUE_VERTE.e99f6c8b.png";